<div class="component d-flex flex-column align-items-center">
  <div class="font-weight-bold text-start font-size-normal text-primary">
    <div [id]="chartId" class="doughnut-status-container"></div>
  </div>
</div>
